import { Bot, Sparkles } from "lucide-react";

const AIAssistantPreview = () => {
  return (
    <div className="relative mx-auto w-full max-w-md lg:max-w-none">
      <div className="absolute -inset-4 rounded-3xl bg-gradient-to-r from-white/20 via-taxby-purple/30 to-white/10 blur-2xl ai-glow-pulse" aria-hidden />

      <div className="relative overflow-hidden rounded-2xl border border-white/25 bg-white/10 p-1 shadow-2xl backdrop-blur-xl">
        <div className="rounded-xl bg-[#1a1035]/90 p-4">
          <div className="mb-4 flex items-center justify-between border-b border-white/10 pb-3">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-taxby-purple/30">
                <Bot className="h-5 w-5 text-white" />
              </span>
              <div>
                <p className="text-sm font-semibold text-white">Asesor Taxby</p>
                <p className="flex items-center gap-1.5 text-xs text-emerald-300">
                  <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 ai-pulse-dot" />
                  IA fiscal · en línea
                </p>
              </div>
            </div>
            <span className="inline-flex items-center gap-1 rounded-full border border-white/15 bg-white/10 px-2 py-1 text-[10px] font-medium uppercase tracking-wide text-white/80">
              <Sparkles className="h-3 w-3" />
              BOE
            </span>
          </div>

          <div className="space-y-3">
            <div className="ml-auto max-w-[85%] rounded-2xl rounded-tr-sm bg-white/15 px-3 py-2 text-sm text-white/95">
              ¿Puedo deducir el alquiler de mi local si facturo online?
            </div>
            <div className="max-w-[92%] rounded-2xl rounded-tl-sm border border-taxby-purple/30 bg-taxby-purple/20 px-3 py-2.5 text-sm leading-relaxed text-white">
              Sí, en estimación directa es deducible si el local es imprescindible para tu actividad.
              Te preparo el gasto en el modelo correcto y reviso el IVA.
            </div>
            <div className="flex items-center gap-2 rounded-xl border border-dashed border-white/15 bg-white/5 px-3 py-2">
              <span className="flex gap-1">
                <span className="h-1.5 w-1.5 rounded-full bg-white/50 ai-typing-dot" />
                <span className="h-1.5 w-1.5 rounded-full bg-white/50 ai-typing-dot [animation-delay:150ms]" />
                <span className="h-1.5 w-1.5 rounded-full bg-white/50 ai-typing-dot [animation-delay:300ms]" />
              </span>
              <span className="text-xs text-white/60">Calculando Modelo 303…</span>
            </div>
          </div>

          <div className="mt-4 grid grid-cols-3 gap-2">
            {[
              { label: "OCR", value: "30s" },
              { label: "BOE", value: "48" },
              { label: "VeriFactu", value: "OK" },
            ].map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg border border-white/10 bg-white/5 px-2 py-2 text-center"
              >
                <p className="text-sm font-bold text-white">{stat.value}</p>
                <p className="text-[10px] text-white/55">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIAssistantPreview;
